import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div
                className="min-h-[60vh] flex items-center justify-center"
                data-testid="auth-loading"
            >
                <div
                    className="font-body text-sm uppercase tracking-[0.22em]"
                    style={{ color: "var(--ns-muted)" }}
                >
                    Verifying session…
                </div>
            </div>
        );
    }
    if (user === false) {
        return (
            <Navigate
                to="/portal/login"
                replace
                state={{ from: location.pathname + location.hash }}
            />
        );
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/portal" replace />;
    }
    return children;
};

export default ProtectedRoute;
